// extracted by mini-css-extract-plugin
export default {"inputLabel":"TextField_inputLabel__liUgR","tooltipRequired":"TextField_tooltipRequired__6e70c"};